import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import { calcUrl } from "@/features/ui/helpers/fetcher-helpers";
import useFetcher from "@/utils/use-fetcher";
import { AxiosRequestConfig } from "axios";

export interface AddProductImageRequest {
  imageUrl: string;
}

export interface AddProductImageResponse {
  id: number;
}

export interface AddProductImagePathParameter {
  productId: number;
}

export const addProductImageTemplateUrl = `/product/:productId/images`;

export const addProductImageKey: YWRKey<AddProductImagePathParameter> = {
  url: (parameter) => {
    return calcUrl(addProductImageTemplateUrl, parameter);
  },
  method: "post",
};

export default function useAddProductImage(
  config?: AxiosRequestConfig<AddProductImageRequest>
) {
  const fetcher = useFetcher<AddProductImageRequest, AddProductImageResponse>();
  return useYWR(addProductImageKey, fetcher, {
    ...config,
    // 외부 이미지를 다운로드해서 s3에 올리기 때문에 넉넉하게 잡는다.
    timeout: 60 * 1000,
  });
}
